import { render, staticRenderFns } from "./AvataraUsuario.vue?vue&type=template&id=562d219a"
import script from "./AvataraUsuario.vue?vue&type=script&lang=js"
export * from "./AvataraUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports